// extracted by mini-css-extract-plugin
export default {"modal":"SelectCandidateGroupModal-module__modal__CDJH5","detail":"SelectCandidateGroupModal-module__detail__1qd4W","content":"SelectCandidateGroupModal-module__content__tMuC7"};